import { render } from "./AccordionItem.vue?vue&type=template&id=390b4c42"
import script from "./AccordionItem.vue?vue&type=script&lang=js"
export * from "./AccordionItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/AccordionItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "390b4c42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('390b4c42', __exports__)) {
    api.reload('390b4c42', __exports__)
  }
  
  module.hot.accept("./AccordionItem.vue?vue&type=template&id=390b4c42", () => {
    api.rerender('390b4c42', render)
  })

}


export default __exports__